// Editable content blocks for Polari Health website

export const clinicInfo = {
  name: "Polar iHealth",
  tagline: "Your Complete Healthcare Partner",
  phone: "519-667-7081",
  fax: "519-661-0083",
  email: "94@polarihealth.com",
  address: "94 Fanshawe Park Rd E., Unit 5A, London, ON N5X 4C5",
  pharmacyPhone: "519-672-9487",
  pharmacyEmail: "northcenterpharmacy94@gmail.com",
  rehabPhone: "519-808-7081",
  rehabEmail: "polarphysiorehab@gmail.com",
  acceptingNewPatients: true, // Toggle this to show/hide new patient acceptance
  hours: {
    monday: "9:00 AM - 7:30 PM",
    tuesday: "9:00 AM - 7:30 PM",
    wednesday: "9:00 AM - 7:30 PM",
    thursday: "9:00 AM - 7:30 PM",
    friday: "9:00 AM - 5:00 PM",
    saturday: "9:00 AM - 12:00 PM",
    sunday: "Closed"
  },
  afterHours: {
    weekdays: "Monday to Thursday: 5:00 PM - 8:00 PM",
    saturday: "Saturday: 9:00 AM - 12:00 PM"
  }
};

export const homeContent = {
  hero: {
    title: "Comprehensive Healthcare in the Heart of London",
    subtitle: "Family medicine, pharmacy, and rehabilitation services all under one roof",
    description: "At Polari Health, we provide personalized, patient-centered care with a full range of medical and wellness services designed to keep you and your family healthy."
  },
  services: [
    {
      id: "family-practice",
      title: "Family Practice",
      description: "Comprehensive primary care for patients of all ages, from routine check-ups to chronic disease management.",
      link: "/family-practice"
    },
    {
      id: "pharmacy",
      title: "On-Site Pharmacy",
      description: "Convenient prescription services, medication counseling, and health consultations right in our clinic.",
      link: "/pharmacy"
    },
    {
      id: "physiotherapy",
      title: "Physiotherapy",
      description: "Evidence-based treatment to restore movement, reduce pain, and improve your quality of life.",
      link: "/physiotherapy"
    },
    {
      id: "chiropractic",
      title: "Chiropractic Care",
      description: "Specialized care for spinal health, pain relief, and overall musculoskeletal wellness.",
      link: "/chiropractic"
    },
    {
      id: "massage",
      title: "Massage Therapy",
      description: "Therapeutic massage to relieve tension, reduce stress, and promote healing.",
      link: "/massage-therapy"
    },
    {
      id: "orthotics",
      title: "Custom Orthotics",
      description: "Precision-fitted orthotics to support your feet and improve your mobility and comfort.",
      link: "/custom-orthotics"
    }
  ]
};

export const familyPracticeContent = {
  title: "Family Practice",
  subtitle: "Compassionate Primary Care for Your Whole Family",
  description: "Our family physicians provide comprehensive healthcare services for patients of all ages. We focus on building long-term relationships with our patients and providing continuity of care.",
  services: [
    "Annual physical examinations",
    "Preventive care and health screenings",
    "Chronic disease management (diabetes, hypertension, etc.)",
    "Acute illness treatment",
    "Minor procedures and wound care",
    "Immunizations and travel medicine",
    "Women's health services",
    "Mental health support and counseling",
    "Referrals to specialists when needed"
  ],
  insurance: "We accept most major insurance plans including OHIP. Please contact us to confirm coverage."
};

export const pharmacyContent = {
  title: "On-Site Pharmacy",
  subtitle: "Convenient Prescription Services",
  description: "Our full-service pharmacy offers convenient access to medications, expert consultation, and personalized care right in our clinic.",
  services: [
    "Prescription filling and refills",
    "Medication therapy management",
    "Immunizations (flu shots, travel vaccines)",
    "Medication synchronization",
    "Blister packaging services",
    "Over-the-counter product consultation",
    "Prescription delivery options",
    "Drug interaction screening",
    "Free delivery"
  ],
  
  insurance: "We work with most insurance providers and can help process your drug benefit claims."
};


export const rehabServicesContent = {
  title: "Rehabilitation Services",
  subtitle: "Complete Care for Your Recovery and Wellness",
  description: "Our integrated rehabilitation team works together to provide comprehensive treatment plans tailored to your unique needs. Whether you're recovering from injury, managing chronic pain, or seeking to improve your overall wellness, we're here to help.",
  services: [
    {
      id: "physiotherapy",
      title: "Physiotherapy",
      description: "Evidence-based assessment and treatment to restore function and mobility.",
      link: "/physiotherapy"
    },
    {
      id: "chiropractic",
      title: "Chiropractic Care",
      description: "Spinal adjustments and manipulation to relieve pain and improve alignment.",
      link: "/chiropractic"
    },
    {
      id: "massage",
      title: "Massage Therapy",
      description: "Therapeutic techniques to promote healing and relaxation.",
      link: "/massage-therapy"
    },
    {
      id: "orthotics",
      title: "Custom Orthotics",
      description: "Custom-fitted foot orthotics for optimal support and comfort.",
      link: "/custom-orthotics"
    }
  ]
};

export const physiotherapyContent = {
  title: "Physiotherapy",
  subtitle: "Restore Movement, Reduce Pain, Improve Function",
  description: "Our registered physiotherapists use evidence-based techniques to help you recover from injury, manage chronic conditions, and optimize your physical health.",
  services: [
    "Musculoskeletal injury treatment",
    "Post-surgical rehabilitation",
    "Sports injury management",
    "Chronic pain management",
    "Manual therapy and joint mobilization",
    "Exercise prescription and movement training",
    "Postural assessment and correction",
    "Work injury rehabilitation",
    "Vestibular rehabilitation"
  ],
  insurance: "Direct billing available for most extended health insurance plans."
};

export const chiropracticContent = {
  title: "Chiropractic Care",
  subtitle: "Natural Approach to Spinal Health and Wellness",
  description: "Our chiropractors specialize in diagnosing and treating musculoskeletal conditions through spinal adjustments, manipulation, and therapeutic interventions.",
  services: [
    "Spinal adjustments and manipulation",
    "Back and neck pain treatment",
    "Headache and migraine management",
    "Sports chiropractic care",
    "Pregnancy chiropractic care",
    "Pediatric chiropractic services",
    "Postural analysis and correction",
    "Soft tissue therapy",
    "Injury prevention education"
  ],
  insurance: "We accept most extended health insurance plans and can provide direct billing."
};

export const massageTherapyContent = {
  title: "Massage Therapy",
  subtitle: "Therapeutic Touch for Healing and Relaxation",
  description: "Our registered massage therapists provide professional therapeutic massage to address pain, tension, and stress while promoting overall wellness.",
  services: [
    "Therapeutic massage",
    "Deep tissue massage",
    "Sports massage",
    "Prenatal massage",
    "Trigger point therapy",
    "Myofascial release",
    "Injury rehabilitation massage",
    "Relaxation massage",
    "Hot stone therapy"
  ],
  insurance: "Covered by most extended health benefit plans with direct billing available."
};

export const customOrthoticsContent = {
  title: "Custom Orthotics",
  subtitle: "Precision Support for Your Feet",
  description: "Our custom orthotic services provide personalized foot support solutions to address pain, improve alignment, and enhance your mobility and comfort.",
  services: [
    "Comprehensive gait and biomechanical assessment",
    "3D foot scanning technology",
    "Custom-molded orthotics",
    "Sports-specific orthotics",
    "Diabetic orthotics",
    "Pediatric orthotics",
    "Orthotic adjustments and modifications",
    "Footwear recommendations",
    "Follow-up care and support"
  ],
  insurance: "Custom orthotics are covered by many extended health plans. We can help with insurance claims."
};

export const teamMembers = [
  {
    id: 1,
    name: "Dr. Zoya Mirza",
    role: "Family Physician",
    credentials: "MD, CCFP",
    bio: "Dr. Mirza Zoya brings a kind, understanding approach to family medicine, serving patients since Polar iHealth's opening in 2022. Fluent in English and Urdu, she excels in pediatric care, senior health, and preventive medicine. Her gentle manner and thorough care help patients of all ages feel comfortable, building lasting relationships with families across London.",
    photo: "https://customer-assets.emergentagent.com/job_wellness-hub-468/artifacts/y484gpca_Zoya%20Mirza2.JPG"
  },
  {
    id: 2,
    name: "Dr. Ayesha Mohar",
    role: "Family Physician",
    credentials: "MD, CCFP",
    bio: "Dr. Mohar is a board-certified family physician from Schulich School of Medicine & Dentistry, known for her thorough, compassionate approach to patient care. Fluent in English, Urdu, and Hindi, she specializes in women's health, prenatal care, and chronic disease management. Patients praise her attentive listening, prompt follow-ups, and caring demeanor that makes every visit comfortable and productive.",
    photo: "https://customer-assets.emergentagent.com/job_wellness-hub-468/artifacts/4h4ultnt_Ayesha%20Mohar%202.JPG"
  },
  {
    id: 3,
    name: "Dr. Arshia Nabeel",
    role: "Family Physician",
    credentials: "MD, CCFP",
    bio: "Dr. Nabeel practices comprehensive family medicine across all age groups, with specialized fellowship training in Care of the Elderly from Western University. Her expertise spans from newborn care to geriatric medicine, with particular focus on senior health, chronic disease management, and age-related conditions. Known for her patient, attentive approach, she provides compassionate care tailored to each patient's life stage and individual needs.",
    photo: "https://customer-assets.emergentagent.com/job_wellness-hub-468/artifacts/sjiogpna_Ayesha%20Nabeel.JPG"
  },
  {
    id: 4,
    name: "Dr. Rupali Sharma",
    role: "Family Physician",
    credentials: "MD, CCFP",
    bio: "Dr. Sharma is a family physician providing comprehensive healthcare to all age groups. She brings vast clinical experience from her extensive practice background. Her international training and diverse patient care experience enable her to deliver culturally sensitive, evidence-based family medicine to the London community.",
    photo: "https://customer-assets.emergentagent.com/job_wellness-hub-468/artifacts/4ynii3j9_Rupali%20Sharma.JPG"
  },
  {
    id: 5,
    name: "Dr. Aziz Akinlade",
    role: "Family Physician",
    credentials: "MD",
    bio: "Registered with CPSO, Dr. Akinlade practices patient-centered family medicine at Polar iHealth (London) and in Ingersoll. His holistic approach considers physical, mental, emotional, and social factors in patient care. Serving all ages from newborns to seniors, he emphasizes preventive care, continuity, and evidence-based treatment, acting as the central point for comprehensive family health needs",
    photo: "https://customer-assets.emergentagent.com/job_wellness-hub-468/artifacts/ru7ifezl_Aziz%20Akinlade%202.JPG"
  },
  {
    id: 6,
    name: "Dr. Noureen Dean",
    role: "Internal Medicine Specialist",
    credentials: "MBBS, MHPE, FRCPC",
    bio: "Dr. Dean is an Internal Medicine Specialist who completed her medical training at Gulf Medical University in the UAE. Her clinical expertise includes General Internal Medicine and peri-operative medicine. With advanced credentials including her Master's in Health Professions Education (MHPE) and Fellowship in the Royal College of Physicians of Canada (FRCPC), she provides specialized care for complex medical conditions and hospital-based medicine.",
    photo: "https://customer-assets.emergentagent.com/job_wellness-hub-468/artifacts/66imw5x5_Noureen%20Dean.JPG"
  },
  {
    id: 8,
    name: "Gurinder Samra",
    role: "Clinic Operations Head",
    credentials: "Healthcare Administration",
    bio: "Gurinder oversees all clinic operations, ensuring smooth coordination between departments and exceptional patient experience. With extensive experience in healthcare management, she leads our administrative team in maintaining the highest standards of care delivery.",
    photo: "https://customer-assets.emergentagent.com/job_wellness-hub-468/artifacts/6rkbx1dl_Gurinder%20Samra%20%282%29.JPG"
  },
  {
    id: 9,
    name: "Administrative Team",
    role: "Patient Care Coordinators",
    credentials: "Healthcare Support",
    bio: "Our friendly administrative staff are the first faces you'll meet at Polari Health. They handle appointments, insurance queries, and ensure your visit runs smoothly from check-in to check-out.",
    photo: "https://customer-assets.emergentagent.com/job_wellness-hub-468/artifacts/ii6x7u6w_Admin%20Staff.JPG"
  }
];

// Pharmacist info (displayed only on Pharmacy page)
export const pharmacist = {
  id: 7,
  name: "Yogesh Patel",
  role: "Pharmacist",
  credentials: "PharmD, RPh",
  bio: "Yogesh brings extensive expertise in medication therapy management and patient counseling, ensuring optimal medication outcomes. His dedication to personalized pharmaceutical care and thorough consultations help patients understand and manage their medications effectively.",
  photo: "https://customer-assets.emergentagent.com/job_wellness-hub-468/artifacts/3bj4ujfz_Yogesh%20Patel.JPG"
};

export const bookingContent = {
  title: "Book an Appointment",
  subtitle: "We're Here to Help",
  description: "Ready to take the next step in your healthcare journey? Contact us to schedule an appointment or ask any questions you may have.",
  methods: [
    {
      icon: "phone",
      title: "Call Us",
      value: "519-667-7081",
      description: "Speak with our friendly staff to book your appointment."
    },
    {
      icon: "mail",
      title: "Email Us",
      value: "94@polarihealth.com",
      description: "Send us a message and we'll get back to you promptly."
    },
    {
      icon: "map-pin",
      title: "Visit Us",
      value: "94 Fanshawe Park Rd E., Unit 5A",
      description: "London, ON N5X 4C5"
    }
  ]
};

export const contactContent = {
  title: "Contact Us",
  subtitle: "Get in Touch",
  description: "Have questions or need assistance? We're here to help. Reach out to us using any of the methods below."
};